import React from 'react';
import PropTypes from 'prop-types';
import { TablePagination } from '@material-ui/core';

function Pagination(props) {
  const {
    page, rowsPerPage, total, setPage, setRowsPerPage,
  } = props;
  return (
    <TablePagination
      rowsPerPageOptions={[10, 20, 50, 100]} // Opciones disponibles para el cambio de paginas
      component="div"
      count={total}
      rowsPerPage={rowsPerPage}
      page={page}
      onChangePage={(event, nextPage) => setPage(nextPage)}
      onChangeRowsPerPage={(event) => setRowsPerPage(event.target.value)}
    />
  );
}

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  setPage: PropTypes.func,
  setRowsPerPage: PropTypes.func,
};

export default Pagination;
